import {api, API_URL} from "../api";
import axios from "axios";

export default class AuthService {
    
    static async tgWebAppSignIn(auth_data) {
        return api.post('/tg-web-app-sign-in', {auth_data})
    }

    static async sendPhoneOtp(phone_number, platform) {
        return api.post('/phone-otp/send', {phone_number, platform})
    }

    static async verifyPhoneOtp(phone_number, otp) {
        return api.post('/phone-otp/verify', {phone_number, otp}, {withCredentials: true})
    }

    static async refreshWithCookie() {
        return axios.get(`${API_URL}/refresh`, {withCredentials: true})
    }

    static async refreshWithHeader(refreshToken) {
        return axios.get(`${API_URL}/tg-or-viewer-refresh`, {
            headers: {
                Authorization: `Bearer ${refreshToken}`
            }
        })
    }

}
